var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.entries = void 0;
  function entries(object) {
    return Object.entries(object);
  }
  exports.entries = entries;
  return exports;
}